import  { useState } from "react";
import logo from "@/assets/icons/maqrah.png";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoIosCloseCircle } from "react-icons/io";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";

import {
  aboutPath,
  academyPath,
  contactPath,
  landingPath,
  studentPath,
  loginPath,
  blogPath,
  waitListPath,
} from "../routes/path";
import { Link } from "react-router-dom";
import { FaFacebook, FaYoutube } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaSquareWhatsapp } from "react-icons/fa6";
import { FaTelegram } from "react-icons/fa6";
import Slides from "./Slides";
import Button from "./Button";

const LandingNav = () => {
  let [toggleArrow, setShow1] = useState(true);
  function handleToggleArrow() {
    setShow1(!toggleArrow);
  }

  const [toggle, setToggle] = useState(true);

  function handleToggle() {
    setToggle(!toggle);
  }
  return (
    <nav className="text-center font-sans ">
      <Slides>
        <div className="absolute sm:min-h-[105vh] min-h-[125vh] inset-0 bg-[#000000df] "></div>
        <div className="relative z-10">
          <div className="transform px-4 flex justify-between items-center">
            <div className="sm:px-10 sm:py-3">
              <Link to={landingPath}>
                {" "}
                <img width={45} src={logo} alt="logo" className="sm:w-24" />
              </Link>
            </div>

            <div className=" sm:w-full sm:py-7 ">
              <div
                className={` flex-col sm:flex-row   flex justify-between sm:shadow-none shadow-md text-[#eaaeff]   
            ${
              toggle
                ? "hidden sm:flex"
                : "block w-[96.5vw] sm:w-full absolute sm:bg-transparent transform bg-white py-5 right-0 left-0 top-10 sm:mt-0 sm:static sm:space-y-0 space-y-3"
            }
          `}
              >
                <ul className=" sm:flex grid items-center pt-1 gap-10 font-semibold sm:text-[#66B2FF] text-[#004C97]  font-600 ">
                  <Link className="hover:text-[#BCC6CC]" to={landingPath}>
                    <li className="">Home</li>
                  </Link>
                  <Link className="hover:text-[#BCC6CC]" to={academyPath}>
                    <div className="flex justify-center items-center">
                      <li className={""}>Academy</li>
                      <div
                        onClick={() => handleToggleArrow()}
                        className="text-[#004C97]"
                      >
                        {!toggleArrow ? (
                          <SlArrowUp className="m-2 text-xs" />
                        ) : (
                          <SlArrowDown className="m-2 text-xs" />
                        )}
                      </div>
                    </div>
                  </Link>
                  <Link className="hover:text-[#BCC6CC]" to={aboutPath}>
                    <li className="">About Us</li>
                  </Link>
                  <Link className="hover:text-[#BCC6CC]" to={contactPath}>
                    <li className="">Contact</li>
                  </Link>
                  <li>
                    <div className="flex sm:text-xl gap-5 text-2xl justify-center items-center ">
                      <a
                        target="_blank"
                        href="https://www.facebook.com/maqrahatultanzeel/"
                      >
                        <FaFacebook className="text-blue-500 hover:text-blue-400" />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/maqrahatultanzeel/"
                      >
                        <FaInstagram className="text-red-600 hover:text-red-400" />
                      </a>
                      <a target="_blank" href="https://wa.me/+2348153783287">
                        {" "}
                        <FaSquareWhatsapp className="text-green-500 hover:text-green-400" />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/@Maqrahaatultanzeel?sub_confirmation=1"
                      >
                        <FaYoutube className="text-red-700 hover:text-red-500" />
                      </a>
                      <a target="_blank" href="https://t.me/maqrahatultanzeel">
                        <FaTelegram className="text-blue-800 hover:text-blue-600" />
                      </a>
                    </div>
                  </li>
                  <Link className="hover:text-[#BCC6CC]" to={studentPath}>
                    <li>Students Profile</li>
                  </Link>
                  <Link className="hover:text-[#BCC6CC]" to={blogPath}>
                    <li>Blog</li>
                  </Link>
                </ul>
                <Link to={academyPath}>
                  <Button
                    btnBgColor={"bg-[#004C97] hover:bg-white hover:shadow-xl"}
                    btnColor={"text-white hover:text-[#3b76db]"}
                    btnText={"Visit Academy"}
                    padding={"py-3 px-6"}
                  />
                </Link>
              </div>
            </div>
            <div className="flex sm:hidden gap-3 p-1 ">
              <div
                onClick={handleToggle}
                className="sm:hidden hover:text-blue-200 text-[#66B2FF]"
              >
                {toggle ? (
                  <RxHamburgerMenu className="text-4xl" />
                ) : (
                  <IoIosCloseCircle className="text-4xl" />
                )}
              </div>
            </div>
          </div>
          <div
            className={` ${
              toggle ? "transform" : "transform-none sm:transform"
            } !`}
          >
            <div className="flex flex-col gap-7 mt-2 sm:mt-1 items-center sm:p-5 p-2">
              <h1 className="text-blue-200 sm:text-4xl text-2xl font-[Roboto] font-extrabold ">
                {" "}
                Welcome To The Best Qur'an Institute <br /> <br />
                Memorize the Quran with Ease & Master the Art of Qira’at
              </h1>{" "}
              <p className="text-blue-50 font-[Mulish] ">
                Join Maqrahaatu Tanzeel, the leading online platform for Quran
                memorization and mastering various styles of Qira’at.
              </p>{" "}
              <p className="text-blue-50 text-sm font-[Mulish]">
                Learn from expert instructors, perfect your recitation, and
                connect with a global community of passionate Quran learners.
              </p>
              <div className=" grid grid-cols-2 sm:grid-cols-3 text-xs sm:text-lg  items-center sm:gap-10 gap-5 ">
                <Link to={academyPath}>
                  <Button
                    btnBgColor={
                      "bg-[#004C97] hover:bg-white hover:text-[#3b76db] hover:rounded-full w-full"
                    }
                    padding={
                      "p-5 sm:px-9  hover:sm:rounded-sm transition-all ease-in-out"
                    }
                    btnColor={" sm:rounded-full text-white"}
                    btnText={"Get Learning Tools"}
                  />
                </Link>
                <Link to={waitListPath}>
                  <Button
                    btnBgColor={
                      "bg-[#3b76db]  hover:bg-white hover:text-[#3b76db] hover:rounded-full "
                    }
                    padding={"p-5 sm:px-9  hover:sm:rounded-sm sm:rounded-full"}
                    btnColor={"text-white transition-all ease-in-out"}
                    btnText={"JOIN WAIT-LIST"}
                  />
                </Link>
                <Link to={loginPath}>
                  <Button
                    btnBgColor={
                      "bg-[#66B2FF] hover:bg-white hover:text-[#3b76db] hover:rounded-full "
                    }
                    padding={"p-5 sm:px-9  hover:sm:rounded-sm sm:rounded-full"}
                    btnColor={"white transition-all ease-in-out w-full"}
                    btnText={"Become Student"}
                  />
                </Link>
                <Link to={studentPath}>
                  <Button
                    btnBgColor={
                      "bg-[#004C97] hover:bg-white hover:text-[#3b76db] hover:rounded-full "
                    }
                    padding={"p-5 sm:px-9  hover:sm:rounded-sm sm:rounded-full"}
                    btnColor={"text-white transition-all ease-in-out w-full"}
                    btnText={"Access Your Profile"}
                  />
                </Link>
                <Link to={"https://forms.gle/wDeTHHiRad5U4PaY6"} type="_Blank">
                  <Button
                    btnBgColor={
                      "bg-[#3b76db]  hover:bg-white hover:text-[#3b76db] hover:rounded-full  w-full"
                    }
                    padding={"p-5 sm:px-9  hover:sm:rounded-sm sm:rounded-full"}
                    btnColor={"text-white transition-all ease-in-out"}
                    btnText={"Enroll Now"}
                  />
                </Link>
                <Link to={blogPath}>
                  <Button
                    btnBgColor={
                      "bg-[#66B2FF] hover:bg-white hover:text-[#3b76db] hover:rounded-full w-full"
                    }
                    padding={"p-5 sm:px-9 hover:sm:rounded-sm sm:rounded-full"}
                    btnColor={" transition-all ease-in-out"}
                    btnText={"View our Blog"}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Slides>
    </nav>
  );
};

export default LandingNav;
